<template>
  <div class="container">
    <van-image
      class="img"
      fit="cover"
      radius="4px"
      :src="coverImageUrl"
      @load="imageLoad"
    >
      <template v-slot:loading>
        <van-loading type="spinner" size="20" />
      </template>
    </van-image>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Image as VanImage } from 'vant'
  import { Loading } from 'vant'
  Vue.use(VanImage)
  Vue.use(Loading)
  export default {
    name: "BlockTopics",
    components: {
    },
    props: {
      slug: {
        type: String,
        default: 'sanhao'
      },
      mode: {
        type: String,
        default: 'banner' // 可选值：detail（详情页）
      },
      topicData: {
        type: Object,
        default: function () {
          return {
          }
        }
      }
    },
    data () {
      return {
        coverImageUrl: '',
      }
    },
    computed: {
    },
    methods: {
      getCoverImage: function(coverId) {
        this.$api.image.detail(coverId)
        .then(res => {
          this.coverImageUrl = res.data.private_cdns[0].cdn_url
        })
      },
      imageLoad: function (e) {
        // window.console.log("image loaded:", e)
        this.$emit('imageonload', {
          imageHeight: e.path[0].height,
          imageWidth: e.path[0].width
        })
      }
    },
    watch: {
    },
    mounted () {
      this.getCoverImage(this.topicData.cover)
    },
  }
</script>

<style lang="css" scoped>
  .img {
    display: block;
    line-height: 0px;
  }
</style>
